import { Button, Grid, TextField, Typography } from '@mui/material';
import { useDispatch} from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import React from 'react';
import { newsDetails } from '../../Actions/News';

const NewsEditorForm = () => {
  const dispatch = useDispatch();
  const validate = Yup.object().shape({
    title: Yup.string().required('Required'),
    startDate: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
  });
  const userData = JSON.parse(localStorage.getItem("access_token"));

  const formik = useFormik({
    initialValues: {
      title: '',
      startDate: '',
      description: '',
    },
    validationSchema: validate,
    onSubmit: (values, onSubmitProps) => {
      dispatch(
        newsDetails({
        title:values.title,
        description:values.description
        },userData.token),
      );

      // setOpen(true);
      onSubmitProps.resetForm();
    },
  });

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <form style={{ width: '100%' }} onSubmit={formik.handleSubmit}>
        <Grid
          Container
          sx={{
            marginTop: 5,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <Typography variant="h5" sx={{ fontFamily: 'Sora', color: 'black', fontWeight: 'bold' }}>
              Enter Your News
            </Typography>
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            marginTop: 6,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
            <TextField
              id="title"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              error={formik.touched.title && Boolean(formik.errors.title)}
              helperText={formik.touched.title && formik.errors.title}
              variant="standard"
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              placeholder="Enter Your News Heading"
              size="small"
              sx={{
                width: '300px',
                p: 1,
                borderRadius: 2,
                backgroundColor: 'white',
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                
                },
              }}
            />
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12} sx={{ marginTop: '10px' }}>
          <TextField
              id="startDate"
              name="startDate"
              value={formik.values.startDate}
              onChange={formik.handleChange}
              error={formik.touched.startDate && Boolean(formik.errors.startDate)}
              helperText={formik.touched.startDate && formik.errors.startDate}
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
              type="date"
              sx={{ width: 220 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          Container
          sx={{
            my: 1,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
        >
          <Grid item md={6} sm={12} xs={12} sx={{ marginTop: '10px' }}>
          <Typography sx={{ fontFamily: 'Sora', opacity: 0.3, fontSize: '14px', my: 1, fontWeight: 'bold' }}>
              Enter Your News Description*
            </Typography>
            <TextField
              id="description"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              error={formik.touched.description && Boolean(formik.errors.description)}
              helperText={formik.touched.description && formik.errors.description}
              variant="standard"
           
              size="small"
             
              sx={{
                width: '70%',
                borderRadius: 2,
                backgroundColor: 'white',
                p: 1,
             
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                },
                height: '100px',
             
              }}
              multiline="true"
              maxRows="4"
              minRows="2"
              InputProps={{
                disableUnderline: true,
                //   style: { color: "#703C00" },
              }}
            />
          </Grid>
        </Grid>

        <Grid
          Container
          sx={{
            marginTop: 2,
            display: 'flex',
            flexDirection: ['column', 'column', 'row'],
          }}
          spacing={0}
        >
          <Grid item md={4} xs={12} sm={12}>
            <Button
              variant="outlined"
              sx={{
                backgroundColor: '#FF7345',
                color: 'white',
                border: 0,
                width: '200px',
                fontFamily: 'Sora',
                '&:hover': {
                  backgroundColor: '#d95429',
                },
              }}
              type="submit"
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default NewsEditorForm;
